<template>
  <pre class="code"><code v-html="jsonHtml"></code></pre>
</template>
<script>
export default {
  methods: {
    replacer(match, pIndent, pKey, pVal, pEnd) {
      const key = '<span class=json-key>';
      const val = '<span class=json-value>';
      const str = '<span class=json-string>';
      const bool = '<span class=json-boolean>';
      let r = pIndent || '';
      if (pKey) r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
      if (pVal) r = r + (pVal.includes("string") ? str : pVal.includes("boolean") ? bool : val) + pVal + '</span>';
      return r + (pEnd || '');
    },
    prettyPrint(obj) {
      const jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
      return JSON.stringify(obj, null, 3)
        .replace(/&/g, '&amp;')
        .replace(/\\"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(jsonLine, this.replacer);
    }
  },
  computed: {
    jsonHtml() {
      return this.prettyPrint(this.json);
    }
  },
  props: ['json']
}
</script>
<style lang="scss">
@import '../styles/_colors';
pre.code {
  color: inherit;
  background-color: black;
}
code {
  .json-key {
    color: $white-ter;
  }
  .json-value {
    color: $blue-light;
  }
  .json-string {
    color: $yellow;
  }
  .json-boolean {
    color: $cyan;
  }
}
</style>
